import { createSelector } from 'reselect';
import get from 'lodash/get';
import moment from 'moment';
import { adContentFilteredMetrics } from '@store/common/selectors';
import { KPI_DIMENSION_METRICS } from '@src/utils/kpi';
import { getColor } from './utils';
import { SCOPE } from './types';

export const selector = (state) => get(state, SCOPE);

export default selector;

export const dimensionDataSelector = createSelector(selector, (store) => store.dimensionsData);

export const widgetsSelector = createSelector(selector, (store) => store.widgets);

export const intervalSelector = createSelector(selector, (store) => store.interval);

export const filterSelector = createSelector(selector, (store) => store.filter.appliedFilters[0]);

export const kpiMetricSelector = createSelector(selector, (store) => store.selectedKPIMetric);

export const filterColorSelector: any = createSelector(filterSelector, (filter) => {
  const { name, rule = [] } = filter;
  const colorIndex = (rule.flat().length || 1) - 1;
  return getColor(colorIndex, name);
});

export const breadcrumbSelector = createSelector(selector, (store) => store.filter.breadcrumb);

// returns true if interval is greater than a day(24h)
// used in overview dashboard to disable devices queries
export const isIntervalGreaterThanADaySelector = createSelector(
  selector,
  ({ interval }) => moment(interval.to).diff(moment(interval.from), 'hours') > 24,
);

// returns true if interval is greater than 30 days
// used for disable viewer sessions
export const isIntervalOlderThanThirtyDaysSelector = createSelector(
  selector,
  ({ interval }) => moment().diff(moment(interval.from), 'days') + 1 > 30,
);

export const isInitializingSelector = createSelector(selector, (store) => store.initializing);

export const dataToPersistSelector = createSelector(
  selector,
  ({ widgets, selectedKPIMetric, filter }) => ({
    widgets,
    selectedKPIMetric,
    filter,
  }),
);

export const kpiDimensionMetricsSelector = createSelector(adContentFilteredMetrics, (metrics) => {
  return KPI_DIMENSION_METRICS.filter((m) => m in metrics);
});

export const selectedKPIConfigSelector = createSelector(
  selector,
  (store) => store.selectedKPIConfig,
);

// export const SPIThresholdSelector = createSelector(
//   (
//     ThresholdsMeta[product]
//   ),
// );
